export const engagementPredictionStatsPredictionId = "/engagement/prediction_stats(/:prediction_id)";
